import React,{useEffect, useState, useContext} from "react";
import {useParams, useNavigate} from "react-router-dom";
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';
import Population from "./Population";
import LandUse from "./LandUse";
import FoodProduction from "./FoodProduction";
import Trade from "./Trade";
import FoodSafetyDefense from "./FoodSafetyDefense";
import Sources from "../Common/Sources";
import ExchangeRate from "./ExchangeRate";
import ClimateLandUse from "./ClimateLandUse";
import FoodSecurity from "./FoodSecurity";
import LeftMenu from './LeftMenu';
import UserContext from "../../contexts/UserContext";

let countryId = 0;
let countryAnswerKeyVal = {};
let countries = [];

function CountryDetails() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [error, setError] = useState(null);
	const [sourceList, setSourceList] = useState([]);
	const [countryName, setCountryName] = useState("");
	let params = useParams();
	const [countryCode, setCountryCode] = useState(params.countryCode);
	const [answerKeyValues, setAnswerKeyValues] = useState({});
	const userCtx = useContext(UserContext);
	let canRead = false;
	if(userCtx){
		canRead = userCtx.isSubscriptionValid;
	}

	useEffect(() => {
		/*fetchCountries();*/
	}, []);
	
	useEffect(() => {
		if (countryCode) {
			setCountryDetails(countryCode);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [countryCode]);
	
	function setCountryDetails(selectedCountryCode) {
		if (countries && countries.length > 0) {
			countries.map((country) => {
				if (country.name.toUpperCase() === selectedCountryCode.toUpperCase()) {
					countryId = country.countryId;
					setCountryName(country.countryName);
					return true;
				}
			});
			fetchCountryAnswers(countryId);
		} else {
			fetchCountries();
		}
	}
	
	function fetchCountries() {
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web"}),
	    };
	    try{
		   FetchUtil.fetchAPI("GetCountries","/Service/StaticHelper/GetCountries", requestOptions, getCountriesSuccess, getCountriesFail);
		} catch (error) {
		   setError(error.message);
		}
	}
  
  	function getCountriesFail(redirect){
  	  setError(t("error.getCountryFailed"));
  	}
  
  	function getCountriesSuccess(responseData){
	  	var countriesResponse;
	  	countries = [];
	  	countryId =0;
	  	if (responseData) {
	    	countriesResponse = responseData.getCountriesResponse;
	     	if (countriesResponse && countriesResponse.errorCode === "0") {
				countries = countriesResponse.countries.slice();
	       		if(countries && countries.length > 0){
					countries.map( (country) =>{
						if(country.name.toUpperCase() === countryCode.toUpperCase()){
							countryId = country.countryId;
							setCountryName(country.countryName);
							return true;
						}
					});
					fetchCountryAnswers(countryId);
				}
	      	} else if (countriesResponse){
		    	setError(t("error.error") + " " +countriesResponse.errorMessage);
	      	}
	 	 }
	}
	function fetchCountryAnswers(countryId) {
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web", countryId: countryId}),
	    };
	    try{
		   FetchUtil.fetchAPI("GetCountryAnswers","/Service/StaticHelper/GetCountryAnswers", requestOptions, getCountryAnswersSuccess, getCountryAnswersFail);
		} catch (error) {
		   setError(error.message);
		}
	}
  
  	function getCountryAnswersFail(redirect){
  	  setError(t("error.getCountryAnswersFailed"));
  	}
  
  	function getCountryAnswersSuccess(responseData){
	  	var countryAnswersResponse;
	  	if (responseData) {
	    	countryAnswersResponse = responseData.getCountryAnswerResponse;
	     	if (countryAnswersResponse && countryAnswersResponse.errorCode === "0") {
				setSourceList([...sourceList, ...countryAnswersResponse.countryInfo.sourceList]);
				mapAnswers(countryAnswersResponse.countryInfo.countryAnswers);
	      	} else if (countryAnswersResponse && countryAnswersResponse.errorCode === "10") {
				// access not present maybe timedout
				logoffUser();
				navigate("/home");
	      	} else if (countryAnswersResponse){
		    	setError(t("error.error") + " " +countryAnswersResponse.errorMessage);
	      	}
	 	 }
	}
	function mapAnswers(countryAnswers){
		countryAnswerKeyVal = {};
		countryAnswers.map( (countryAnswer) =>{
				countryAnswerKeyVal[countryAnswer.key] = countryAnswer.text;
				countryAnswerKeyVal[countryAnswer.key+"_sources"] = countryAnswer.sourceId;
				countryAnswerKeyVal["country_code"] = countryCode.toLowerCase();
				return true;
		})
		setAnswerKeyValues({...countryAnswerKeyVal});
	}
	
	function logoffUser(){
		userCtx.addUserName("");
		userCtx.addLoggedInUserId("");
		userCtx.addRole("");
		userCtx.addIsAuthenticated(false);
		userCtx.addIsSubscriptionValid(false);
		userCtx.addLang("");
		userCtx.addTosTimeStamp("");
		userCtx.addEnabledMFA(0);
		userCtx.clearStorage();
	}
	
	function isNotEmpty(obj) {
       return Object.keys(obj).length > 0;
    }
  	return (
		<div id="page">
		 {(error) && (
	        <div id="inerrorMessage" className="alert.alert-danger">
	          {error}
	        </div>
	      )}
	      <div className="page-inner">
	      	<div className="output-main">
	      		 <div className="row">
         			<div className="col-3">
         			{(countryId > 0 && isNotEmpty(answerKeyValues) )? 
         			<LeftMenu canRead={canRead} countryAnswers={{answerKeyValues}} countryList={countries} defaultCountry={countryCode} />
         			: ""}
         			</div>
         			<div className="col-9">
         				<div className="clearfix" style={{marginBottom: "20px"}}>
							<div className="pull-left">
								<h1>{countryName}</h1>
								<small style={{ marginTop: "-15px"}}>
								ISO Codes:
									<span>{answerKeyValues['iso_code_alpha_2_digit']}</span> 
									<span>{", " + answerKeyValues['iso_code_alpha_3_digit']}</span>
									<span>{" | Capital City: " + answerKeyValues['capital_city']}</span>
								</small>
								<Population countryAnswers={{answerKeyValues}} />
								<ExchangeRate countryAnswers={{answerKeyValues}} countryName={countryName} />
								<ClimateLandUse countryAnswers={{answerKeyValues}} />
								<LandUse countryAnswers={{answerKeyValues}} />
								<FoodSecurity countryAnswers={{answerKeyValues}} />
								<FoodProduction countryAnswers={{answerKeyValues}} />
								<Trade countryAnswers={{answerKeyValues}} />
								<FoodSafetyDefense countryAnswers={{answerKeyValues}} />
								<Sources sourceList={{sourceList}} />
							</div>
						</div>
         			</div>
         		</div>
	      	</div>
	      </div>
        </div>
  );
}
export default CountryDetails;
